import React, { Component } from 'react';
import { Container, Grid, Segment, Header } from 'semantic-ui-react';
import { connect } from 'react-redux';
import _ from 'underscore';

import {
    getHradminEmployeeListData,
} from '../../actions'
import HradminEmployeeSearchBar from '../../component/hradmin/employee/search_bar';
import HradminEmployeeListTable from '../../component/hradmin/employee/list_table';

const filterEmployeeArray = (searchType, searchText, employees) => {
    if (searchType && searchText) {
        employees = _.filter(employees, (employee) => {
            if (employee[searchType].toLowerCase().indexOf(searchText.toLowerCase()) !== -1) {
                return employee;
            }
        });;
    }
    return employees;
}

class HradminEmployeeListPage extends Component {

    state = {
        searchType: null,
        searchText: null,
    }

    componentDidMount() {
        const {accessToken} = this.props.user;
        this.props.getHradminEmployeeListData(accessToken);
    }

    updateSearchParameters = (searchType, searchText) => {
        this.setState({searchType, searchText});
    }

    render() {
        const filteredEmployeeListData = filterEmployeeArray(this.state.searchType, this.state.searchText, this.props.employeelistData);
        return (
            <Container>
                <Grid columns={1}>
                    <Grid.Column>
                        <Header attached="top" block>
                            Employees - View / Search Employee
                        </Header>
                        <Segment attached>
                            <HradminEmployeeSearchBar
                                updateSearchParameters={this.updateSearchParameters}
                            />
                        </Segment>
                    </Grid.Column>
                    <Grid.Column>
                        <HradminEmployeeListTable
                            employees={filteredEmployeeListData}
                        />
                    </Grid.Column>
                </Grid>
            </Container>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        employeelistData: state.hradmin.employeelistData,
        user: state.user.user,
    };
}

export default connect(mapStateToProps, {
    getHradminEmployeeListData,
})(HradminEmployeeListPage);